
export default {
  props: ["createTime", "path", "showPic", "name"],
};
